import { takeLatest, put } from 'redux-saga/effects';

import {
  grupoContaAgrareWhiteLabel,
  NEW_GRUPO_CONTA_AGRARE_WHITE_LABEL,
  NEW_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
} from '@handler';

function* sagaNewGrupoContaAgrareWhiteLabel(action) {

  yield put({
    type: NEW_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
    registro: grupoContaAgrareWhiteLabel.newRegistro,
    isCadastroRapido: action.isCadastroRapido,
  });
}

export default function* watchNewGrupoContaAgrareWhiteLabel() {
  yield takeLatest(NEW_GRUPO_CONTA_AGRARE_WHITE_LABEL, sagaNewGrupoContaAgrareWhiteLabel)
}
